import React from 'react';
import { Reveal } from './Reveal';
import { EyeOffIcon, MessageCircleOffIcon, UsersIcon, HeartCrackIcon } from 'lucide-react';
const ATTEMPTS = [{
  icon: EyeOffIcon,
  title: 'El "Contacto Cero"',
  body: 'Terminaste espiando sus redes desde una cuenta falsa, alimentando la obsesión.'
}, {
  icon: MessageCircleOffIcon,
  title: 'Buscar un "cierre"',
  body: 'Pediste una última charla que solo te dejó con más dudas y menos dignidad.'
}, {
  icon: UsersIcon,
  title: 'Escuchar a tus amigos',
  body: '"Pero si no eran nada, supéralo" — solo te hizo sentir más solo/a y avergonzado/a.'
}, {
  icon: HeartCrackIcon,
  title: 'Ser "el amigo/a cool"',
  body: 'No exigías nada mientras te rompías por dentro cada vez que te ignoraban.'
}];
export function WhyFailed() {
  return <section className="w-full bg-midnight py-24" data-id="element-181">
      <div className="mx-auto max-w-5xl px-6" data-id="element-182">
        <Reveal data-id="element-183">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-electric" data-id="element-184">
            Por qué lo que intentaste no funcionó
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold text-cream sm:text-4xl" data-id="element-185">
            Cada intento te dejó más enganchado/a.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-186">
          {ATTEMPTS.map((item, i) => <Reveal key={item.title} delay={i * 0.08} data-id="element-187">
              <div className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7" data-id="element-188">
                <item.icon className="h-7 w-7 text-rose-glow" data-id="element-189" />
                <h3 className="mt-4 font-display text-xl font-semibold text-cream" data-id="element-190">
                  {item.title}
                </h3>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-191">{item.body}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}